import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { tokens, Stack } from '@hotjar/hotsauce';
import { ToggleButton as ToggleHighlightButton } from '@hotjar/webapp/features/Highlights/Heatmaps';
import type { Site } from '@hotjar/site';
import { useFeatureFlag } from '@hotjar/feature-flags';
import { SMART_PANEL_LAYERS_SECTION } from '@hotjar/heatmaps';
import { DownloadDropdown } from './components/DownloadDropdown';
import { TrafficIndicatorDropDown } from './components/TrafficIndicatorDropdown';

import { ViewRecordingsLink } from './components/ViewRecordingsLink';

const ActionsContainer = styled(Stack)`
  display: inline-flex;
  height: ${tokens.spacer.x5};
  align-items: center;
`;

interface StatusBarActionsProps {
  filtersApplied: boolean;
  highlights: {
    activate: () => void;
    deactivate: () => void;
    isActive: boolean;
  };
  site: Site | undefined;
  onDownloadData: () => void;
  onDownloadImage: () => void;
}

export const StatusBarActions = ({
  highlights,
  filtersApplied,
  site,
  onDownloadData,
  onDownloadImage,
}: StatusBarActionsProps): JSX.Element => {
  const { t } = useTranslation();
  const isLayersSectionEnabled = useFeatureFlag(SMART_PANEL_LAYERS_SECTION);

  return (
    <ActionsContainer spacing="x1">
      <ViewRecordingsLink />

      {!isLayersSectionEnabled && (
        <ToggleHighlightButton
          onToggle={highlights?.isActive ? highlights?.deactivate : highlights?.activate}
          isActive={highlights?.isActive}
          disabledText={t('heatmaps:statusbar.availability.only-in-screenshot')}
        />
      )}

      <DownloadDropdown onDownloadImage={onDownloadImage} onDownloadData={onDownloadData} />

      <TrafficIndicatorDropDown filtersApplied={filtersApplied} site={site} />
    </ActionsContainer>
  );
};
